import { render } from "./Tab2.vue?vue&type=template&id=360a94b8"
import script from "./Tab2.vue?vue&type=script&lang=js"
export * from "./Tab2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__